"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getXirrUiConfig = exports.getDefaultXirrUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketRules_1 = require("../bucketRules");
var bucketHelper_1 = require("../bucketHelper");
exports.getDefaultXirrUiConfig = function () { return cloneDeep_1.default(uiConfig_1.DEFAULT_XIRR_UICONFIG); };
function getCustomError(_a, formatMessage) {
    var buckets = _a.buckets;
    var measuresCount = bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.MEASURES);
    var attributeCount = bucketHelper_1.getItemsCount(buckets, sdk_ui_1.BucketNames.ATTRIBUTE);
    if (measuresCount === 0 || attributeCount === 0) {
        return {
            heading: formatMessage({ id: "dashboard.xirr.error.invalid_buckets.heading" }),
            text: formatMessage({ id: "dashboard.xirr.error.invalid_buckets.text" }),
        };
    }
    return undefined;
}
exports.getXirrUiConfig = function (referencePoint, intl) {
    var _a;
    var uiConfig = bucketHelper_1.setBucketTitles(tslib_1.__assign(tslib_1.__assign({}, referencePoint), { uiConfig: exports.getDefaultXirrUiConfig() }), sdk_ui_1.VisualizationTypes.XIRR, intl);
    var buckets = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : [];
    var canAddMeasures = bucketRules_1.hasNoMeasures(buckets);
    var canAddAttribute = bucketRules_1.hasNoAttribute(buckets);
    set_1.default(uiConfig, [bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "canAddItems"], canAddMeasures);
    set_1.default(uiConfig, [bucket_1.BUCKETS, sdk_ui_1.BucketNames.ATTRIBUTE, "canAddItems"], canAddAttribute);
    uiConfig.customError = getCustomError(referencePoint, intl.formatMessage);
    return uiConfig;
};
//# sourceMappingURL=xirrUiConfigHelper.js.map